var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/ui/components/bundle.tsx";
import "core-js/modules/web.dom-collections.iterator.js";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';

const emptyComponent = () => null;

const noop = () => {};

/** Fetches and renders an async component. */
class Bundle extends React.PureComponent {
  constructor() {
    super(...arguments);

    _defineProperty(this, "timeout", void 0);

    _defineProperty(this, "timestamp", void 0);

    _defineProperty(this, "state", {
      mod: undefined,
      forceRender: false
    });

    _defineProperty(this, "load", props => {
      const {
        fetchComponent,
        onFetch,
        onFetchSuccess,
        onFetchFail,
        renderDelay
      } = props || this.props;
      const cachedMod = Bundle.cache.get(fetchComponent);

      if (fetchComponent === undefined) {
        this.setState({
          mod: null
        });
        return Promise.resolve();
      }

      onFetch();

      if (cachedMod) {
        this.setState({
          mod: cachedMod.default
        });
        onFetchSuccess();
        return Promise.resolve();
      }

      this.setState({
        mod: undefined
      });

      if (renderDelay !== 0) {
        this.timestamp = new Date();
        this.timeout = setTimeout(() => this.setState({
          forceRender: true
        }), renderDelay);
      }

      return fetchComponent().then(mod => {
        Bundle.cache.set(fetchComponent, mod);
        this.setState({
          mod: mod.default
        });
        onFetchSuccess();
      }).catch(error => {
        this.setState({
          mod: null
        });
        onFetchFail(error);
      });
    });
  }

  componentDidMount() {
    this.load(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.fetchComponent !== this.props.fetchComponent) {
      this.load(nextProps);
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  render() {
    const {
      loading: Loading,
      error: Error,
      children,
      renderDelay
    } = this.props;
    const {
      mod,
      forceRender
    } = this.state;
    const elapsed = this.timestamp ? new Date().getTime() - this.timestamp.getTime() : renderDelay;

    if (mod === undefined) {
      return elapsed >= renderDelay || forceRender ? /*#__PURE__*/React.createElement(Loading, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 102,
          columnNumber: 57
        }
      }) : null;
    }

    if (mod === null) {
      return /*#__PURE__*/React.createElement(Error, {
        onRetry: this.load,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 106,
          columnNumber: 14
        }
      });
    }

    return children(mod);
  }

}

_defineProperty(Bundle, "defaultProps", {
  loading: emptyComponent,
  error: emptyComponent,
  renderDelay: 0,
  onFetch: noop,
  onFetchSuccess: noop,
  onFetchFail: noop
});

_defineProperty(Bundle, "cache", new Map());

export default Bundle;